// extracted by mini-css-extract-plugin
export var attachmentContainer = "_rx-0";
export var fileList = "_rx-2";
export var removeFileButton = "_rx-1";